import Command from './command';
import CommandResult from './command-result';
import DeleteCommand from './delete';
export default Command.extend({
  processZeroWidth() {
    if (this.get('firstSelectedBlock.isTextType') || this.get('firstSelectedBlock.isListType')) {
      let mutationResult = this.applyActionToFirstSelectedBlock('deleteWord');
      this.setSelectionToPositionIndex(mutationResult.get('blockRange.startPoint.positionIndex'));
      return CommandResult.create({
        shouldRerender: true
      });
    } else {
      return this._doDelete();
    }
  },
  processSingleBlock() {
    return this._doDelete();
  },
  processMultiBlock() {
    return this._doDelete();
  },
  _doDelete() {
    return DeleteCommand.create({
      blockList: this.get('blockList'),
      selection: this.get('selection'),
      config: this.get('config')
    }).run();
  }
});